module.exports = __webpack_public_path__ + "img/quiz_button.9da655f7.jpg";